// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w2tJ","controls":"styles_controls__1oUeK","charLimit":"styles_charLimit__3KF1K","input":"styles_input__1cNiI","send":"styles_send__1x8bO"};